// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {
    getClaimTypes
} from '../../shared/repositories';

export const readFacetsData = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const allPromises = Promise.all.bind(Promise);

        try {

            const [claimTypes] = await allPromises([
                getClaimTypes()
            ]);

            dispatch({
                data: claimTypes,
                type: actions.READ_CLAIM_SEARCH_CLAIM_TYPES_SUCCESS
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/claim-search/action-creators/read-facets-data.js